import { IUser } from "../models/IUser";
import { makeAutoObservable } from "mobx";
import AuthService from "../service/AuthService";
import $api, { API_URL } from "../http";
import axios from "axios";
import { showErrorToast, showSuccessToast } from "../components/toasts";

export default class Store {
  user = {} as IUser;
  isAuth = false;

  constructor() {
    makeAutoObservable(this);
  }

  setAuth(bool: boolean) {
    this.isAuth = bool;
  }

  setUser(user: IUser) {
    this.user = user;
  }

  async login(email: string, password: string) {
    try {
      const res = await AuthService.login(email, password);
      localStorage.setItem("token", res.data.accessToken);
      this.setUser(res.data.user);
      this.setAuth(true);
      showSuccessToast("Login Successfully");
      return res.data.user;
    } catch (error: any) {
      this.setAuth(false);
      showErrorToast(`${error?.response?.data?.message}`)
      return { error: error };
    }
  }

  async logout() {
    try {
      await AuthService.logout();
      localStorage.removeItem("token");
      this.setUser({} as IUser);
      this.setAuth(false);
      showSuccessToast("Logout Successfully");
    } catch (e: any) {
      console.error(e.response?.data?.message);
    }
  }

  async checkAuth() {
    try {
      const res = await $api.get(`/user/refresh`, {
        withCredentials: true,
      });
      localStorage.setItem("token", res.data.accessToken);
      this.setUser(res.data.user);
      this.setAuth(true); 
    } catch (e: any) {
      console.log(e);
      console.error(e);
    }
  }
}
